import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { api } from "@api/api";
import { ApiError } from "@shared/types";
import { Partner } from "@modules/partners/types";

import { listPartnersQueryKey } from "../../queries/listPartners/query";

export function useRejectPartnerMutation() {
  const translate = useTranslate();
  const { open } = useNotification();
  const queryClient = useQueryClient();

  return useMutation<Partner, ApiError, { id: number; rejection_reason: string }>({
    mutationFn: async ({ id, rejection_reason }) => {
      const { data } = await api.post<Partner>(`/v1/partner_admin/${id}/reject/`, {
        rejection_reason,
      });
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: listPartnersQueryKey,
        refetchType: "all",
      });
      open?.({ type: "success", message: translate("v1/partner_admin.success.reject") });
    },
    onError: (error: ApiError) => {
      open?.({ type: "error", message: error.response.data.error });
    },
  });
}
